import React, { Component, PropTypes } from 'react'
import { Link } from 'react-router'
import { connect } from 'react-redux'
import { getClientsSaga } from 'client/features/client/sagas'
import { ClientsRequest, HiveRequest, setCurrentClient } from 'client/features/client/actions'
import URLS from 'constant/URLS'
import FontAwesome from 'react-fontawesome'
import ClientName from 'client/features/client/components/ClientName.jsx'
import ClientForm from 'client/features/client/components/ClientForm.jsx'
import ClientAddress from 'client/features/client/components/ClientAddress.jsx'
import DeleteModal from 'client/features/client/components/DeleteClientModal.jsx'
import DeleteHiveModal from 'client/features/client/components/DeleteHiveModal.jsx'
import Hive from 'client/features/client/components/Hive.jsx'

class Client extends Component {
    constructor() {
        super()
        this.deleteClient = this.deleteClient.bind(this)
        this.deleteHive = this.deleteHive.bind(this)
        this.updateClient = this.updateClient.bind(this)
        this.updateHive = this.updateHive.bind(this)
        this.displayDeleteClientModal = this.displayDeleteClientModal.bind(this)
        this.displayDeleteHiveModal = this.displayDeleteHiveModal.bind(this)
        this.newHive = this.newHive.bind(this)
        this.state = {
            showDeleteClientModal: false
        }
    }

    componentWillMount() {
        const currentId = this.props.params.id
        this.props.dispatch(setCurrentClient(currentId))
    }
    
    deleteClient() {
        this.props.dispatch(ClientsRequest.delete.action({ params: { id: this.props.params.id } }))
        this.setState({
            showDeleteClientModal: false
        })
    }
    
    deleteHive(hive) {
        this.props.dispatch(HiveRequest.delete.action({ payload: { hive }, params: { id: this.props.params.id, hive } }))
        this.setState({
            showDeleteHiveModal: false
        })
    }

    newHive() {
        this.props.dispatch(HiveRequest.post.action({ params: { id: this.props.params.id } }))
    }

    updateClient(payload) {
        const emails = []
        for (const key in payload) {
            if (key.match('email') && payload[key] && key !== 'email' && key !== 'emails')
                emails.push(payload[key])
        }
        payload.emails = emails
        if (payload.address) {
            payload = {...payload, ...payload.address }
            delete payload.address
        }
        this.props.dispatch(ClientsRequest.put.action({ payload, params: { id: this.props.params.id } }))
    }

    updateHive(payload) {
        payload.active === true ? null : payload.active = false
        this.props.dispatch(HiveRequest.put.action({ payload, params: { id: this.props.params.id, hive: payload._id } }))
    }

    renderHives() {
        if (!this.props.client || !this.props.client.hives) return
        return this.props.client.hives.filter((hive) => !hive.deleted).map((hive) =>
            <Hive
                initialValues={ hive }
                hive={ hive }
                key={ hive._id }
                onSubmit={ this.updateHive }
                name={ `hive-${hive._id}` }
                deleteHive={ this.displayDeleteHiveModal }
            />
        )
    }

    displayDeleteClientModal() {
        this.setState({
            showDeleteClientModal: !this.state.showDeleteClientModal,
        })
    }

    displayDeleteHiveModal(currentHive) {
        this.setState({
            showDeleteHiveModal: !this.state.showDeleteHiveModal,
            currentHive
        })
    }

    render() {
        const { client } = this.props
        if (!client) return (<div></div>)
        return (
            <div>
                <div className='row'>
                    <div className='col-md-12'>
                        <span className='pull-right'>
                            <a className='btn btn-danger btn-xs waves-effect' onClick={ this.displayDeleteClientModal }>
                                Supprimer
                            </a>
                        </span>
                        <DeleteModal
                            show={ this.state.showDeleteClientModal }
                            display={ this.displayDeleteClientModal }
                            deleteClient={ this.deleteClient }
                            client={ client }
                        />
                        <DeleteHiveModal
                            show={ this.state.showDeleteHiveModal }
                            display={ this.displayDeleteHiveModal }
                            deleteHive={ this.deleteHive }
                            hive={ this.state.currentHive }
                        />
                        <ClientForm
                            onSubmit={ this.updateClient }
                        />
                        <hr />
                        <div className='row'>
                            <div className='col-md-12'>
                                <h4>
                                    Hives
                                    <span className='pull-right'>
                                        <a className='btn btn-success btn-xs waves-effect' onClick={ this.newHive }>
                                            Ajouter une ruche
                                        </a>
                                    </span>
                                </h4>
                                <table className='table table-striped m-0'>
                                    <thead>
                                        <tr>
                                            <th style={{ width: 120 }}>ID</th>
                                            <th>Visible <br />dans l'app</th>
                                            <th>Morte</th>
                                            <th className='text-right'>Sauver</th>
                                            <th className='text-right'>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            this.renderHives()
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

Client.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    user: PropTypes.object
}

const mapStateToProps = (state) => {
    const { client } = state
    return {
        client: client.current
    }
}

export default connect(mapStateToProps)(Client)


// WEBPACK FOOTER //
// ./src/client/features/client/containers/Client.jsx